/**
 * 报表模块接口
 * @description 各类报表查询相关接口
 */

import axios from "@/utils/request";
import Api from "../api";
import * as Request from "../request.type";
import * as ResponseData from "../response.type";

/**
 * 获取报表供应商旅游产品类别
 * @param data 报表供应商旅游产品类别数据
 * @returns 报表供应商旅游产品类别结果
 */
export const Http_getReportSupplierTourProductCategory = async (
  /** 产品ID */
  grade: number
) => {
  return axios
    .get<ResponseData.ReportSupplierTourProductCategory[]>(
      Api.GET_REPORT_SUPPLIER_TOUR_PRODUCT_CATEGORY,
      {
        params: {
          grade,
        },
      }
    )
    .then((res) => {
      if (res.code === 0) {
        res.data.forEach((item) => {
          item.nameCn = item.name;
        });
      }
      return res;
    });
};

/**
 * 获取报表供应商旅游产品类型
 * @param data 报表供应商旅游产品类型数据
 * @returns 报表供应商旅游产品类型结果
 */
export const Http_getReportSupplierTourProductType = async (
  /** 产品类别ID */
  categoryList: number[]
) => {
  return axios
    .post<ResponseData.ReportSupplierTourProductType[]>(
      Api.POST_REPORT_SUPPLIER_TOUR_PRODUCT_TYPE,
      {
        categoryList,
      }
    )
    .then((res) => {
      if (res.code === 0) {
        res.data.forEach((item) => {
          item.nameCn = item.name;
        });
      }
      return res;
    });
};

/**
 * 获取报表供应商旅游产品商品列表
 */
export const Http_getReportSupplierTourProductList = async (
  typeList: number[]
) => {
  return await axios.post<ResponseData.ReportSupplierTourProductListData[]>(
    Api.POST_REPORT_SUPPLIER_TOUR_PRODUCT_LIST,
    {
      typeList,
    }
  );
};

/**
 * 获取报表供应商旅游产品供应商列表
 */
export const Http_getReportSupplierTourProductSupplierList = async () => {
  const res =
    await axios.get<ResponseData.ReportSupplierTourProductSupplierListData>(
      Api.GET_REPORT_SUPPLIER_TOUR_PRODUCT_SUPPLIER_LIST,
      {
        params: {
          pageNum: 1,
          pageSize: 1000,
        },
      }
    );
  if (res.code === 0) {
    res.data.list.forEach((item) => {
      item.nameCn = item.supplierName;
    });
  }
  return res;
};

export interface SeatHoldLineItem extends ResponseData.LineInfoItem {
  /** 上站列表 */
  onStations: ResponseData.StationInfo[];
  /** 下站列表 */
  offStations: ResponseData.StationInfo[];
}

/**
 * 获取取位留位统计路线列表
 */
export const Http_getSeatHoldLineList = async () => {
  return await axios.get<SeatHoldLineItem[]>(Api.GET_SEAT_HOLD_LINE_LIST);
};

/**
 * 获取万能销售报表表头列表
 */
export const Http_getUniversalSaleReportHeaderList = async () => {
  return await axios.get<
    {
      /** 表头ID */
      id: string;
      /** 表头名称 */
      nameCn: string;
      /** 是否默认选中 */
      defaultSelected: boolean;
    }[]
  >(Api.GET_UNIVERSAL_SALE_REPORT_HEADER_LIST);
};

/**
 * 获取万能取位报表表头列表
 */
export const Http_getUniversalSeatHoldReportHeaderList = async () => {
  return await axios.get<
    {
      /** 表头ID */
      id: string;
      /** 表头名称 */
      nameCn: string;
      /** 是否默认选中 */
      defaultSelected: boolean;
    }[]
  >(Api.GET_UNIVERSAL_HOLD_REPORT_HEADER_LIST);
};
// ==================== 任务管理模块 ====================

/**
 * 获取任务列表
 * @param params 任务列表查询参数
 * @returns 任务列表结果
 */
export const Http_getTaskManagePage = async (
  params: Request.GetTaskManagePageParams
) => {
  return await axios.post<ResponseData.TaskManagePageData>(
    Api.POST_TASK_MANAGE_PAGE,
    params
  );
};

/**
 * 暂停任务
 * @param params 暂停任务参数
 * @returns 暂停结果
 */
export const Http_cancelTask = async (params: Request.CancelTaskParams) => {
  return await axios.post(Api.POST_TASK_CANCEL, params);
};

/**
 * 恢复任务
 * @param params 恢复任务参数
 * @returns 恢复结果
 */
export const Http_recoverTask = async (params: Request.RecoverTaskParams) => {
  return await axios.post(Api.POST_TASK_RECOVER, params);
};

/**
 * 设置任务最高优先级
 * @param params 设置优先级参数
 * @returns 设置结果
 */
export const Http_pinTaskToTop = async (params: Request.PinTaskToTopParams) => {
  return await axios.post(Api.POST_TASK_PIN_TO_TOP, params);
};

/**
 * 删除任务
 * @param params 删除任务参数
 * @returns 删除结果
 */
export const Http_deleteTask = async (params: Request.DeleteTaskParams) => {
  return await axios.post(Api.POST_TASK_DELETE, params);
};
